var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlutter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    enableBackground: "new 0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#44C8F5",
    d: "M72.6,256.8l69.6,69.8L439,30.1L309.6,30c-12,0-9.1-1.3-14.5,4.2 L72.6,256.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#005899",
    d: "M246.8,431.1c4.5,5.2,10.3,10.4,15.2,15.3l34.4,34.4 c1.6,1.7,1.9,2.8,4.6,2.9c4.8,0.3,10.7,0,15.7,0c40.8,0,81.5,0,122.3,0c-3-4.4-119.7-119-121.7-122.4l-0.7,0.1 c-2.5,3-5.9,5.9-8.7,8.8C299.7,378.2,248.4,428.1,246.8,431.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#44C8F5",
    d: "M246.9,291.8l69.5,69.5l0.7-0.1c3.5-4.5,102.3-102.4,117.6-117.7 c1.4-1.4,3.1-2.4,3.7-4.4c-40.6,0-81.2,0-121.7,0c-5,0-10.2-0.1-15.2,0c-3.3,0.1-3.1,0.8-4.9,2.7 C290.1,248.3,248.3,289.3,246.9,291.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#29B7EA",
    d: "M246.8,431.1c1.7-3,52.9-52.9,61-60.9c2.9-2.9,6.2-5.8,8.7-8.8 l-69.5-69.5c-1.6,0.7-7.3,6.9-8.7,8.3c-6.3,6.3-59.4,58.9-61,61.3L246.8,431.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/flutter.be83473af3547a644c9e7be29e2c2c1b.svg";
export { ForwardRef as ReactComponent };